import store from '@/state/store';
import { registrationByInvitation } from '@/api/auth';
import { ClaimAndPasswordRequest } from '@bimdata/definitions/dto';
import authenticationSlice from '@/state/authentication.slice';
import { initSession } from '@/loaders/profile';
import { handleError } from '../common';

export default async (data: ClaimAndPasswordRequest) => {
  try {
    await registrationByInvitation(data);
    store.dispatch(authenticationSlice.actions.finishLogin());
    await initSession();
  } catch (error) {
    handleError(error);
  }
};
